module.exports = __webpack_public_path__ + "img/check-mark.81ce95aa.svg";